import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import simplebar from "simplebar-vue";
import BaseMixer from "@/router/views/BaseMixer";
import { AssetMasterModule } from "@/store/modules/asset.module";
import { AssetReportModel } from "@/store/models/asset/assetReportDTO";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { toaster } from "@/utilities/toaster";
Component.registerHooks(["metaInfo"]);
let AssetPurchaseReport = /** @class */ (() => {
    let AssetPurchaseReport = class AssetPurchaseReport extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Asset Purchase Report";
            this.pageIsLoading = false;
            this.isPageLoading = false;
            this.assetPurchaseReport = new AssetReportModel();
            this.showTable = false;
            this.showText = true;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Reports",
                },
                {
                    text: "Asset Purchase Report",
                    active: true,
                },
            ];
        }
        get assetReportDetails() {
            return AssetMasterModule.assetReportDetails;
        }
        getAssetDetails() {
            this.validate("validateObserver").then((res) => {
                if (res) {
                    this.pageIsLoading = true;
                    this.showText = false;
                    this.assetPurchaseReport.startDateAsString = this.dateFormattedString(this.assetPurchaseReport.startDate);
                    this.assetPurchaseReport.endDateAsString = this.dateFormattedString(this.assetPurchaseReport.endDate);
                    if (this.assetPurchaseReport.startDate > this.assetPurchaseReport.endDate) {
                        toaster.ShowError("Start date should not be greater than end date.");
                    }
                    AssetMasterModule.GetAssetPurchaseReport(this.assetPurchaseReport).then((res) => {
                        if (res) {
                            this.showTable = true;
                            this.pageIsLoading = false;
                        }
                    });
                }
            });
        }
        clearDate() {
            this.assetPurchaseReport.startDate = null;
            this.assetPurchaseReport.endDate = null;
            this.getAssetDetails();
        }
        GenerateAssetDetailReportAsExcel() {
            this.isPageLoading = true;
            this.validate("validateObserver").then((res) => {
                if (res) {
                    this.assetPurchaseReport.startDateAsString = this.dateFormattedString(this.assetPurchaseReport.startDate);
                    this.assetPurchaseReport.endDateAsString = this.dateFormattedString(this.assetPurchaseReport.endDate);
                    AssetMasterModule.GetAssetPurchaseReportAsExcel(this.assetPurchaseReport).then((res) => {
                        if (res) {
                            const blob = new Blob([res], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            document.body.appendChild(link);
                            link.download = `AssetPurchaseReport.xlsx`;
                            link.click();
                            this.isPageLoading = false;
                        }
                    });
                }
            });
        }
        created() { }
    };
    AssetPurchaseReport = __decorate([
        Component({
            name: "AssetPurchaseReport",
            components: {
                Loader,
                SectionLoader,
                Layout,
                PageHeader,
                simplebar,
            },
        })
    ], AssetPurchaseReport);
    return AssetPurchaseReport;
})();
export default AssetPurchaseReport;
